import React from "react";
import { useNavigate } from "react-router-dom";
import { Email } from "../../../types/Email";
import IconButton from "../../../components/IconButton";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import cx from "classnames";
import styles from '../EmailsOverview.module.css';
import { toSlug } from "../../../helpers/stringHelper";

type EmailListProps = {
    emails: Email[];
};

const EmailListView: React.FC<EmailListProps> = ({
    emails
}) => {
    const navigate = useNavigate();

    const handleEmailClick = (email: Email) => {
        const slug = toSlug(email.company || email.email);
        navigate(`/emails/${email.id}/${slug}`);
    };

    return (
        <div className={cx(styles['list-container'])}>
            {emails.map((email) => (
                <div key={email.id} className={cx(styles['list-item'], 'zr-d-flex', 'zr-justify-between', 'zr-items-center')}>
                    <div className={cx(styles['email-info'])}>
                        <div className={cx(styles['list-title'])} onClick={() => handleEmailClick(email)} style={{ cursor: 'pointer' }}>
                            {email.company || email.email}
                        </div>
                        <div className={cx(styles['email-details'])}>
                            {email.email && <span>{email.email}</span>}
                            {(email.firstName || email.lastName) && (
                                <>
                                    {email.email && <span> • </span>}
                                    <span>{[email.firstName, email.lastName].filter(Boolean).join(' ')}</span>
                                </>
                            )}
                            {email.phoneNumber && (
                                <>
                                    {(email.email || email.firstName || email.lastName) && <span> • </span>}
                                    <span>{email.phoneNumber}</span>
                                </>
                            )}
                            {email.postalCode && (
                                <>
                                    {(email.email || email.firstName || email.lastName || email.phoneNumber) && <span> • </span>}
                                    <span>{email.postalCode}</span>
                                </>
                            )}
                            {email.city && (
                                <>
                                    {(email.email || email.firstName || email.lastName || email.phoneNumber || email.postalCode) && <span> • </span>}
                                    <span>{email.city}</span>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default EmailListView;

